import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=35254242&scoped=true"
import script from "./PostCreate.vue?vue&type=script&lang=js"
export * from "./PostCreate.vue?vue&type=script&lang=js"
import style0 from "./PostCreate.vue?vue&type=style&index=0&id=35254242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35254242",
  null
  
)

export default component.exports